import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";

const AddCountry = () => {
  const [countryName, setCountryName] = useState("");
  const [countries, setCountries] = useState([]);

  // Fetch all countries
  const fetchCountries = async () => {
    try {
      const response = await axios.get(`${baseurl}getAllCountries`);
      setCountries(response.data.countries);
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  // Fetch countries on component mount
  useEffect(() => {
    fetchCountries();
  }, []);

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!countryName.trim()) {
      Swal.fire("Validation Error", "Country name is required", "warning");
      return;
    }

    console.log("Sending Data:", { country_name: countryName });

    try {
      await axios.post(`${baseurl}addCountry`, { country_name: countryName });

      Swal.fire("Success", "Country added successfully!", "success").then(
        () => {
          setCountryName("");
          fetchCountries(); // Refresh the country list
        }
      );
    } catch (error) {
      console.error("Error adding country:", error);
      Swal.fire("Error", "Failed to add country. Try again!", "error");
    }
  };

  // Define table columns
  const columns = [
    { name: "ID", selector: (row) => row.id, sortable: true },
    {
      name: "Country Name",
      selector: (row) => row.country_name,
      sortable: true,
    },
  ];

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />

        <div class="container-fluid">
          <h4 class="mb-3 text-start">Country List</h4>
          <div class="crd1 mb-3">
            <div class="row">
              
            <form onSubmit={handleSubmit}>
  <div className="row mb-3 align-items-end">
    {/* Input Field */}
    <div className="col-md-6">
      {/* <label className="form-label">Country Name</label> */}
      <input
        type="text"
        className="form-control"
        placeholder="Enter Country Name"
        value={countryName}
        onChange={(e) => setCountryName(e.target.value)}
      />
    </div>

    {/* Button */}
    <div className="col-md-6 d-flex">
      <button type="submit" className="btn btn-primary mt-auto">
        Add Country
      </button>
    </div>
  </div>
</form>
<div className="mt-4">
            {/* <h4>Country List</h4> */}
            <DataTable
              columns={columns}
              data={countries}
              pagination
              highlightOnHover
            />
          </div>
             
            </div>
          </div>


           
        </div>

        
      </div>
    </div>
  );
};

export default AddCountry;
